<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> گزارش چک ها  </span>

    </div>

</div>

<main style="direction: rtl;" class="py-4 px-2">

    <!-- فرم جستجو -->

    <form class="row gx-2 gy-3" [formGroup]="searchModel">

        <!-- از تاریخ -->

        <div class="col-12 col-md-2 position-relative">

            <label class="mb-2 text-muted">  از تاریخ </label>
    
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
    
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
    
                <input type="text" formControlName="strSDate" placeholder="از تاریخ" class="form-control text-end" />
    
            </ng-persian-datepicker>
    
        </div>

        <!-- تا تاریخ -->

        <div class="col-12 col-md-2 position-relative">

            <label class="mb-2 text-muted">  تا تاریخ </label>
    
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
    
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
    
                <input type="text" formControlName="strEDate" placeholder="از تاریخ" class="form-control text-end" />
    
            </ng-persian-datepicker>
    
        </div>

        <!-- مبلغ بیشتر از -->

        <div class="col-12 col-md-3 position-relative">

            <label class="mb-2 text-muted"> مبلغ بیشتر از </label>

            <input class="form-control p-2 text-center" formControlName="iDebit">

        </div>

        <!-- جستجو -->

        <div class="col-12 col-md-auto position-relative border border-2 b-transparent">

            <button class="btn btn-primary px-4 w-100" (click)="searchChecks()" > جستجو </button>

        </div>

        <!-- ارسال پیام -->

        <div class="col-12 col-md-auto position-relative border border-2 b-transparent">

            <button class="btn btn-danger w-100" (click)="message_Modal()"> ارسال پیام </button>

        </div>

        <!-- چاپ -->

        <div class="col-12 col-md-auto position-relative border border-2 b-transparent">

            <button printTitle="گزارش چک ها" printSectionId="print-table" 
            
                [useExistingCss]="true" ngxPrint class="btn btn-warning w-100" >
                
                &nbsp; چاپ &nbsp;
            
            </button>

        </div>

        <!-- خروجی اکسل -->

        <div class="col-12 col-md-auto position-relative border border-2 b-transparent">

            <button class="btn btn-success w-100" (click)="exportExcel()"> خروجی اکسل </button>

        </div>

    </form>

    <!-- نمایش اطلاعات -->

    <div class="border border-2 mt-3 p-2" >

        <input type="text" class="w-100 form-control" placeholder="جستجو کنید ...">

        <div class="section border border-2 mt-2" style="height:calc(100vh - 220px);overflow: auto;" id="print-table">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>
            
                    <tr class="col-12 text-center">
        
                        <th class="text-center col-1"> # </th>

                        <th (click)="selectAllCheckBox()" class="pointer"> انتخاب </th>
    
                        <th class="text-center"> مدرسه </th>
            
                        <th class="text-center"> دانش آموز </th>

                        <th class="text-center"> تاریخ </th>

                        <th class="text-center"> مبلغ (ریال)  </th>

                        <th class="text-center"> توضیحات </th>
    
                    </tr>
                    
                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of list_Checks;let i = index">

                        <th> {{ i + 1 | faNum }} </th>

                        <td>
                            
                            <input type="checkbox" (change)="setCheckBox($event.target.checked,item)"
                            
                                [checked]="isSelected(item.iPassenger)">
                            
                        </td>

                        <td> {{ item.strMobileDomain_strComment }} </td>

                        <td> {{ item.strPassenger_FullName }} </td>

                        <td> {{ item.strDate | faNum }} </td>

                        <td> {{ item.iCredit.toLocaleString() | faNum }} </td>

                        <td> {{ item.strComment }} </td>

                    </tr>

                    <tr *ngIf="list_Checks.length > 0" 
                        
                        class="col-12 text-center" 
                        
                        style="background-color: #c7d2fe;">

                        <th> </th>

                        <td></td>

                        <td></td>

                        <td></td>

                        <td></td>

                        <td> سرجمع : {{ check_Obj.iTotal.toLocaleString() | faNum }} </td>

                        <td> </td>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

</main>


<!-- ارسال پیام  -->

<div class="modal fade" id="sendMessage" tabindex="-1" aria-labelledby="" aria-hidden="true" data-backdrop="false" data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-lg">

        <form #message="ngForm" (ngSubmit)="sendMessage(message)" class="modal-content p-1">

            <div class="modal-header dirI">

                <h5 class="modal-title"> ارسال پیام </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div dir="rtl" class="modal-body row gx-1 gy-2 w-100">

                <!-- متن پیام -->

                <div class="col-12 p-1">

                    <textarea class="form-control" style="resize: none;"
                    
                        ngModel name="strMessage"  cols="20" rows="7"
                        
                        placeholder="متن پیام خود را وارد کنید ...">

                    </textarea>

                </div>

                <!-- ارسال پیام درون برنامه ای -->
                
                <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-1">

                    <input class="form-check-input m-0" type="checkbox" id="bSendPush" [ngModel]="false" name="bSendPush">
                
                    <label class="form-check-label pointer text-muted me-2" for="bSendPush"> ارسال پیام درون برنامه ای </label>
                
                </div>

                <!-- ثبت پیام در کارتابل -->

                <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-1">

                    <input class="form-check-input m-0" type="checkbox" id="bSaveMessage" [ngModel]="false" name="bSaveMessage">
                
                    <label class="form-check-label pointer text-muted me-2" for="bSaveMessage"> ثبت پیام در کارتابل </label>
                
                </div>

                <!-- همراه با مبلغ بدهکاری -->

                <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-1">

                    <input class="form-check-input m-0" type="checkbox" id="bWithDebit"[ngModel]="false" name="bWithDebit">
                
                    <label class="form-check-label pointer text-muted me-2" for="bWithDebit"> همراه با مبلغ بدهکاری </label>
                
                </div>

            </div>

            <div class="modal-footer">

                <button class="btn btn-primary" type="submit"> 

                    &nbsp; ارسال &nbsp;
                    
                </button>

            </div>

        </form>

    </div>
    
</div>
